import React from 'react';

const FieldViewerContext = React.createContext();

export default FieldViewerContext;
